// Vendors
import { TrackingEventsEnum, TrackingLinkEventReturnType } from '@openbank/cf-ui-static-data';
// Types
import { LinkTrackingPropsType } from './types/banner-download-app-tracking.configurations.types';

export const getLinkTypeTrackingConfiguration = ({
  eventAction,
  eventLabel,
}: LinkTrackingPropsType): TrackingLinkEventReturnType => ({
  payload: {
    eventAction,
    eventLabel,
  },
  type: TrackingEventsEnum.LINK,
});
